import { LandingPageTypes } from '../../helpers/domain/landingPages';

const eventSourceMap = new Map([
  [LandingPageTypes.HomePage, 'HP'],
  [LandingPageTypes.CondoPage, 'CDO'],
  [LandingPageTypes.HousePage, 'HM'],
  [LandingPageTypes.TownhomePage, 'TWH'],
  [LandingPageTypes.ProjectResearchPage, 'RSRCH'],
  [LandingPageTypes.LocationInsightPage, 'LOCIN'],
  [LandingPageTypes.ZonesPage, 'ZON'],
  [LandingPageTypes.TrainlinesPage, 'RWY'],
  [LandingPageTypes.NewsPage, 'NEWS'],
  [LandingPageTypes.PropertyNewsPage, 'PPNEWS'],
  [LandingPageTypes.GeneralNewsPage, 'GENNEWS'],
  [LandingPageTypes.GuidesPage, 'GUIDES'],
  [LandingPageTypes.BuyAndSellPage, 'BNS'],
  [LandingPageTypes.InvestmentPage, 'INVT'],
  [LandingPageTypes.FinancePage, 'FIN'],
  [LandingPageTypes.DecorsPage, 'DECOR'],
  [LandingPageTypes.InteriorInspirationPage, 'IINSP'],
  [LandingPageTypes.RenovationPage, 'RENO'],
  [LandingPageTypes.MaintenancePage, 'MNT'],
  [LandingPageTypes.ReviewPage, 'REV'],
  [LandingPageTypes.PreviewPage, 'PRVW'],
  [LandingPageTypes.PointOfViewPage, 'POV'],
  [LandingPageTypes.ReviewCondoPage, 'REV CDO'],
  [LandingPageTypes.ReviewHousePage, 'REV HM'],
  [LandingPageTypes.ReviewTownhomePage, 'REV TWH'],
  [LandingPageTypes.PreviewCondoPage, 'PRVW CDO'],
  [LandingPageTypes.PreviewHousePage, 'PRVW HM'],
  [LandingPageTypes.PreviewTownhomePage, 'PRVW TWH'],
  [LandingPageTypes.HomeOfficePage, 'HMO'],
  [LandingPageTypes.MixedUsePage, 'MCK'],
  [LandingPageTypes.VacationPage, 'GOV'],
]);

export const generateEventSourceByPageType = (
  pageType: LandingPageTypes,
): string => eventSourceMap.get(pageType);
